import { render, staticRenderFns } from "./activeList.vue?vue&type=template&id=4dbf95dc&scoped=true"
import script from "./activeList.vue?vue&type=script&lang=js"
export * from "./activeList.vue?vue&type=script&lang=js"
import style0 from "./activeList.vue?vue&type=style&index=0&id=4dbf95dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf95dc",
  null
  
)

export default component.exports